import React from 'react'

import Box from '@/modules/components/Box'
import Flex from '@/modules/components/Flex'
import { useOneLink } from '@/modules/components/hooks/useOneLink'
import Link from '@/modules/components/Link'
import appStoreBadge from '@/modules/images/footer/app-store-badge.png'
import playStoreBadge from '@/modules/images/footer/play-store-badge.png'

export const Downloads = () => {
  const { queryString } = useOneLink()

  return (
    <Flex>
      <Box marginRight={1}>
        <Link href={`https://crypto.onelink.me/RSfq${queryString}`}>
          <img src={appStoreBadge} alt="Appstore image" height={40} />
        </Link>
      </Box>
      <Link href={`https://crypto.onelink.me/veNW${queryString}`}>
        <img src={playStoreBadge} alt="Playstore image" height={40} />
      </Link>
    </Flex>
  )
}
